import { Timestamp } from "firebase/firestore";

/**
 * Calculates the next service date based on the completed date and work type.
 * @param {Date|Timestamp|string} completedDate - The date the service was completed.
 * @param {string} workType - Type of work (Installation, Regular Service, AMC, Breakdown).
 * @returns {Date|null} - The next service date or null if not applicable.
 */
export const calculateNextServiceDate = (completedDate, workType) => {
    if (!completedDate || !workType) return null;

    // Convert Firestore Timestamp or string to Date object
    let dateObj = completedDate;
    if (completedDate instanceof Timestamp) {
        dateObj = completedDate.toDate();
    } else if (typeof completedDate === "string") {
        dateObj = new Date(completedDate);
    }

    if (isNaN(dateObj.getTime())) return null;

    const nextDate = new Date(dateObj); // Create a copy so we don't mutate original
    let intervalMonths = 0;

    switch (workType) {
        case "Installation":
        case "Regular Service":
            intervalMonths = 4;
            break;
        case "AMC":
            intervalMonths = 6;
            break;
        case "Breakdown":
        default:
            return null; // No scheduled service for Breakdown or unknown types
    }

    // Add months
    nextDate.setMonth(nextDate.getMonth() + intervalMonths);

    return nextDate;
};

/**
 * Returns the service interval in months for a given work type.
 * @param {string} workType 
 * @returns {number} - Months (4, 6, or 0)
 */
export const getServiceInterval = (workType) => {
    switch (workType) {
        case "Installation":
        case "Regular Service":
            return 4;
        case "AMC":
            return 6;
        default:
            return 0;
    }
};
